import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { signInWithEmail } from '@/lib/platform/auth';
import { enterAfterAuth } from '@/lib/platform/routing';
import { entry } from '@/routes';

export function SignInPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string>();
  const [busy, setBusy] = useState(false);
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <div className="w-full max-w-md border border-border bg-card p-8">
        <p className="text-sm font-semibold tracking-[0.18em]">FIDUCIARYFILE</p>
        <h1 className="mt-10 text-3xl font-semibold tracking-tight">Sign in</h1>
        <p className="mt-2 text-sm text-muted-foreground">Continue to your filing workspace.</p>
        <div className="mt-8 grid gap-5">
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          {message && <p className="text-sm text-destructive">{message}</p>}
          <Button
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              setMessage(undefined);
              const result = await signInWithEmail(email, password);
              if (result.ok) await enterAfterAuth(entry);
              else setMessage(result.message);
              setBusy(false);
            }}
          >
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </div>
        <p className="mt-6 text-sm text-muted-foreground">
          Need an account?{' '}
          <Link className="text-primary underline" to="/sign-up">
            Create one
          </Link>
        </p>
      </div>
    </main>
  );
}
